import React, { useEffect } from 'react';
import { OverlayProps } from './Overlay.types';
import * as S from './Overlay.styles';
import { useAnimatedVisibility } from '@/hooks/useAnimatedVisibility';

export const Overlay = ({
  isOpen,
  opacity,
  syncScrollHeight = false,
  ...props
}: OverlayProps) => {
  const { isVisible, onAnimationEnd } = useAnimatedVisibility(isOpen);

  useEffect(() => {
    if (!isVisible || !syncScrollHeight) return;

    function updateOverlayHeight() {
      document.documentElement.style.setProperty(
        '--overlay-doc-height',
        `${Math.max(
          document.documentElement.scrollHeight,
          document.body.scrollHeight,
          window.innerHeight
        )}px`
      );
    }

    updateOverlayHeight();
    window.addEventListener('resize', updateOverlayHeight);
    window.addEventListener('scroll', updateOverlayHeight, { passive: true });

    const resizeObserver = new ResizeObserver(updateOverlayHeight);
    resizeObserver.observe(document.documentElement);
    resizeObserver.observe(document.body);

    return () => {
      window.removeEventListener('resize', updateOverlayHeight);
      window.removeEventListener('scroll', updateOverlayHeight);
      resizeObserver.disconnect();
    };
  }, [syncScrollHeight, isVisible]);

  if (!isVisible) return null;

  return (
    <S.OverlayBox
      $isOpen={isOpen}
      $opacity={opacity}
      $coverDocument={syncScrollHeight}
      onAnimationEnd={onAnimationEnd}
      {...props}
    />
  );
};
